export const INCREMENT = 'INCREMENT';
export const DECREASE = 'DECREASE';
export const ADDISSUE = 'ADDISSUE';
export const REMOVEISSUE = 'REMOVEISSUE';
export const LOAD = 'LOAD';
export const LOAD_SUCESS = 'IMAGES_LOAD_SUCESS';
export const LOAD_FAIL = 'IMAGES_LOAD_FAILD';
